export default __webpack_public_path__ + "static/media/eye-no.1ca58150.svg";